import { GetPlanOutput } from "@smash-sdk/billing";

export interface SmashPriceProps {
    price: number;
    currency: 'usd' | 'eur';
}

export const smashPriceformatter = (price: number, currency: GetPlanOutput['plan']['currency']): string => currency === 'eur' ? `${price}€` : `$ ${price}`

const SmashPrice = (props: SmashPriceProps) => {
    return <span>{smashPriceformatter(props.price, props.currency)}</span>
}


export default SmashPrice;
